import { ArrayParam, useQueryParam, withDefault } from 'use-query-params';

export const OPTIONS = [
  {
    label: 'Day shift',
    value: 'day',
  },
  {
    label: 'Night shift',
    value: 'night',
  },
  {
    label: 'Evening',
    value: 'evening',
  },
];

interface IUseSchedule {
  schedule: string[];
  setSchedule: (schedule: string[]) => void;
  clearSchedule: () => void;
  hasSchedule: boolean;
}

export const useSchedule = (): IUseSchedule => {
  const [schedule, setQuery] = useQueryParam('schedule', withDefault(ArrayParam, []));

  const clearSchedule = () => setQuery(undefined, 'replaceIn');

  const setSchedule = (schedule) =>
    schedule?.length ? setQuery(schedule, 'replaceIn') : clearSchedule();

  return {
    schedule,
    setSchedule,
    clearSchedule,
    hasSchedule: !!schedule?.length,
  };
};

export default useSchedule;
